import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-between w-full my-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-black text-center w-full mt-2" }, "Obrigado! Recebemos o seu feedback.", -1)
const _hoisted_3 = { class: "flex justify-center items-center w-full mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UseIcon = _resolveComponent("UseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UseIcon, {
      name: "IconSuccess",
      color: "#63C3BE",
      size: "70"
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        type: "button",
        class: "rounded-full font-regular text-sm flex flex-col justify-center bg-brand-gray items-center py-2 px-5 cursor-pointer focus:outline-none"
      }, " Envie mais feedbacks ")
    ])
  ]))
}